"use client";

import { useMemo } from "react";
import { useBlockedDatesQuery } from "../api/queries";
import { listingService } from "../services";

export function useBlockedDates(listingId: number) {
  const { data, isLoading, error } = useBlockedDatesQuery(listingId);
  const { blockedDates, checkoutOnlyDates } = useMemo(
    () => listingService.groupBlockedDates(data ?? []),
    [data],
  );
  return {
    blockedDates,
    checkoutOnlyDates,
    loading: isLoading,
    error: error ? error.message || "Failed to fetch blocked dates" : null,
  };
}
